module.exports = __webpack_public_path__ + "img/dataservice_zcjg.62cbe566.png";